export const formatToOnlyPositiveIntegers = (value: string | number) => {
  const salary = String(value).replace(/\D/g, '');

  if (parseInt(salary) < 1) {
    return '';
  }

  return salary;
};
